module.exports = __webpack_public_path__ + "static/media/calendar.88f5fb88.svg";